import type { FirestoreSectionAssignment } from '../types'
import { AssignmentState, AssignmentStatus } from '../types'

export function getAssignmentStatus(
  assignment: FirestoreSectionAssignment
): AssignmentStatus {
  if (assignment.assignmentState === AssignmentState.unconfigured) {
    return AssignmentStatus.unconfigured
  }
  if (assignment.assignmentState === AssignmentState.draft) {
    return AssignmentStatus.draft
  }
  if (assignment.assignmentState === AssignmentState.canceled) {
    return AssignmentStatus.canceled
  }
  const assignedAtIsInFuture = assignment.assignedAt
    ? assignment.assignedAt.getTime() > Date.now()
    : false
  if (assignedAtIsInFuture) {
    return AssignmentStatus.pending
  }
  const expiresAtIsInPast = assignment.expiresAt
    ? assignment.expiresAt.getTime() < Date.now()
    : false
  if (expiresAtIsInPast) {
    return AssignmentStatus.completed
  }
  return AssignmentStatus.in_progress
}
